







































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {IChangeUserPasswordPopup, SelectOption} from "@/global";
import * as enums from '@/global-enum'
import usersApi from '@/api/users'

@Component({
    components: {
    }
})
export default class ChangeUserPasswordPopup extends Vue implements IChangeUserPasswordPopup {
    isPopupVisible = false;
    isLoading = false;
    isButtonsDisabled = false;

    currentPassword = "";
    newPassword = "";
    confirmNewPassword = "";

    get validateForm(): boolean {
        return !this.veeErrors.any();
    }

    @Watch("currentPassword")
    onCurrentPasswordUpdate(val: string, oldVal: string) {
        if (val === oldVal) return;
        this.currentPassword = this.$appUtils.specialUserPasswordTrim(this.currentPassword);
    }

    @Watch("newPassword")
    onNewPasswordUpdate(val: string, oldVal: string) {
        if (val === oldVal) return;
        this.newPassword = this.$appUtils.specialUserPasswordTrim(this.newPassword);
    }

    showError(errorMessage?: string) {
        this.$bvToast.toast(errorMessage || "Спробуйте пізніше", {
            title: "Помилка",
            variant: "danger"
        })
    }

    isValidationScopeValid(scope: string) {
        return this.$appUtils.vvIsValidationScopeValid(this, scope);
    }

    validateState(ref: string, scope?: string) {
        return this.$appUtils.vvValidateState(this, ref, scope);
    }

    async openChangeUserPasswordPopup() {
        this.isPopupVisible = true;

        // this.isLoading = true;
        // this.isLoading = false;
    }

    onChangeUserPasswordPopupClosed() {
        // reset values
        this.isButtonsDisabled = false;

        this.currentPassword = "";
        this.newPassword = "";
        this.confirmNewPassword = "";
    }

    async changePassword() {
        let isValid = await this.$validator.validateAll('changeUserPasswordPopup-changePassword');

        if (isValid) {
            this.isButtonsDisabled = true;

            usersApi.changePassword(this.currentPassword, this.newPassword, data => {
                if (data.success) {
                    this.$bvToast.toast("Пароль змінен успішно", {
                        title: "Успіх",
                        variant: "success"
                    });

                    this.isPopupVisible = false;
                } else {
                    this.$bvToast.toast("Не вдалося змінити пароль", {
                        title: "Помилка",
                        variant: "danger"
                    });
                }

                this.isButtonsDisabled = false;
            }, errorMessage => {
                this.isButtonsDisabled = false;

                this.showError(errorMessage)
            });
        }
    }
}
